import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_check",
  "use": "icon-ic_check-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_check\">\n<g id=\"icon-ic_check_ic_check\">\n<path id=\"icon-ic_check_Vector\" d=\"M9.87863 15.6621L19.071 6.46973L20.4852 7.88394L9.87863 18.4905L3.51465 12.1266L4.92886 10.7124L9.87863 15.6621Z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol